import { FC, useEffect, useState } from "react";
import useGridFilter from "../../../../../system/hooks/useGridFilter";
import { DefaultGrid } from "../../../../../components/grids/default/defaultGrid";
import { useAppContext } from "../../../../../system/providers/appContextProvider";
import { usePluginContext } from "../../../../../system/providers/plugin";
import BaseCommandsPanel from "../../../../../components/commandsPanels/BaseCommandsPanel";
import { Tooltip } from "antd";
import { ExpenseDocumentsButton } from "../../../../../components/buttons/iconButtons/special/QuickAccessBarCollection";
import { useTabsContext } from "../../../../../system/providers/tabsProvider";
import styles from '../Styles/ScanBoxView.module.scss'
import { Spinner } from "../../../../../components/spiner/Spinner";
import { IKiz2DocumentGetDTO, IKizBoxGismtDTO } from "../../../../../libs/coreapi-dto/dirs/kiz";
import { objectToMap } from "../../../../../system/functions/objectToMap";
import axios from "axios";
import { envF } from "../../../../../env";

export interface IScanBoxGismtViewProps extends ISelectorGridProps {
    gridId: string,
    plugin: IPluginSettings,
    baseGridFilter?: IGridFilter,
    id?: string
    documentId?: string
}

const ScanBoxGismtView: FC<IScanBoxGismtViewProps> = (props) => {
    const appCtx = useAppContext()
    const pluginCtx = usePluginContext()
    const tabsCtx = useTabsContext();
    const [data, setData] = useState<IKizBoxGismtDTO[]>([])
    const [totalCount, setTotalCount] = useState(0)
    const [gridFilter, dispatchGridFilter] = useGridFilter()
    const [selectedItem, setSelectedItem] = useState<IGridRow>();
    const [masterSelectedItem, setMasterSelectedItem] = useState<ISelectGridRow | undefined>()
    const [isSubmitting, setIsSubmitting] = useState<boolean>(true);

    const getDocumentIdGlobal = (): string | undefined => {
        const openedTabsWithSelectionsMap: Map<string, string> = objectToMap(
            JSON.parse(localStorage.getItem('openedTabsWithSelections') || '{}')
        );
        const idTabCurrent = tabsCtx.currentTab?.id ?? "";

        return pluginCtx.masterGrid.selectedItem?.idGlobal
            ?? (idTabCurrent ? openedTabsWithSelectionsMap.get(idTabCurrent) : undefined);
    };

    const fetchData = (documentIdGlobal: string) => {
        setIsSubmitting(true)
        const jwtToken = localStorage.getItem("TokenData") as string;
        const token = `Bearer ${JSON.parse(jwtToken).accessToken}`;

        axios.get<IKiz2DocumentGetDTO>(
            `${envF.REACT_APP_API_GATEWAY_PATH}/Kiz/Document/${documentIdGlobal}`,
            { headers: { Authorization: token } }
        )
        .then((response) => {
            const allBoxGismt = response.data.items.flatMap(item => item.kizBoxesGisMt ?? []);
            setData(allBoxGismt);
            setTotalCount(allBoxGismt.length);
        })
        .catch(() => {
            setData([]);
            setTotalCount(0);
        })
        .finally(() => {
            setIsSubmitting(false);
            if (pluginCtx.masterGrid.view == true && pluginCtx.masterGrid.selectedItem) {
                pluginCtx.masterGrid.refreshState(false)
            }
        })
    }

    useEffect(() => {
        const documentIdGlobal = props.documentId ?? getDocumentIdGlobal();

        if (documentIdGlobal) {
            if ((!masterSelectedItem || masterSelectedItem && masterSelectedItem.idGlobal !== documentIdGlobal) || pluginCtx.masterGrid.view === true) {
                setMasterSelectedItem(pluginCtx.masterGrid.selectedItem)
                fetchData(documentIdGlobal)
            }
        }
    }, [pluginCtx.masterGrid.selectedItem, pluginCtx.masterGrid.view, tabsCtx.currentTab?.id, props.documentId])

    useEffect(() => {
        if (pluginCtx.masterGrid.selectedItem) {
            fetchData(pluginCtx.masterGrid.selectedItem.idGlobal)
        }
    }, [gridFilter])

    return (
        <>
            <div className={styles.toolsPanel}>
                <BaseCommandsPanel groups={[
                    [
                        {
                            iconButton: <Tooltip title='Переход в журнал КИЗ'>
                                <ExpenseDocumentsButton sizeVariant="mini" onClick={() => {
                                    tabsCtx.openChild('kiz_exchange_plugin', undefined, undefined, undefined, data.find(x => x.idGlobal === selectedItem?.idGlobal)?.barcode)
                                }}
                                />
                            </Tooltip>
                        },
                    ]
                ]} />
            </div>
            {
                isSubmitting ?
                    <Spinner />
                    :
                    <DefaultGrid
                        separator
                        gridId={props.gridId}
                        data={data}
                        filter={gridFilter}
                        totalCount={totalCount}
                        plugin={props.plugin}
                        selectedItem={selectedItem}
                        onDoubleClick={(row) => props.onDoubleClick?.(row)}
                        onSelect={(row) => {
                            setSelectedItem(row)
                            props.onSelect?.(row)
                        }}
                        onSort={(i) => { dispatchGridFilter({ type: "sort", payload: i.propertyName }) }}
                        onFilterDelete={(i) => { dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName }) }}
                        onPageNumberChange={(n) => { dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } }) }}
                        onNumberPerPageChange={(n) => {
                            dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })
                        }}
                    />
            }
        </>
    )
}
export default ScanBoxGismtView
